'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');
var Badge = require('../../../node_modules/@material-ui/core/esm/Badge/Badge.js');
var Tab = require('../../../node_modules/@material-ui/core/esm/Tab/Tab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: _objectSpread({
      textTransform: 'none',
      transition: 'padding-left 0.5s',
      paddingLeft: 'unset',
      lineHeight: '24px',
      letterSpacing: 0,
      fontWeight: 400,
      minHeight: 40,
      height: 40
    }, theme.typography.body2),
    wrapper: {
      alignItems: 'flex-start',
      marginLeft: theme.spacing(3)
    },
    selected: {
      paddingLeft: theme.spacing(2),
      fontWeight: 500,
      wordBreak: 'break-all'
    },
    textColorInherit: {
      opacity: 'unset',
      color: theme.palette.grey[900]
    },
    badgeItem: {
      display: 'inline-flex',
      alignItems: 'center',
      width: '90%',
      justifyContent: 'space-between'
    }
  };
});
var LeftNavigationItemWithTab = React__default["default"].forwardRef(function (_ref, ref) {
  var badgeValue = _ref.badgeValue,
      tabProps = objectWithoutProperties(_ref, ["badgeValue"]);

  var _useStyles = useStyles(),
      root = _useStyles.root,
      wrapper = _useStyles.wrapper,
      selected = _useStyles.selected,
      textColorInherit = _useStyles.textColorInherit,
      badgeItem = _useStyles.badgeItem;

  var label = tabProps.label;

  if (badgeValue) {
    label = React__default["default"].createElement("div", {
      className: classNames__default["default"](badgeItem, defineProperty({}, selected, tabProps.selected))
    }, React__default["default"].createElement("span", null, tabProps.label), React__default["default"].createElement(Badge["default"], {
      badgeContent: badgeValue,
      color: "primary",
      anchorOrigin: {
        horizontal: 'left',
        vertical: 'top'
      }
    }));
  }

  return React__default["default"].createElement(Tab["default"], _objectSpread({
    classes: {
      root: root,
      wrapper: wrapper,
      selected: selected,
      textColorInherit: textColorInherit
    }
  }, tabProps, {
    label: label,
    ref: ref
  }));
});

module.exports = LeftNavigationItemWithTab;
